<script>
import MainLayout from '../layouts/mainLayout'
import {DateUtil} from '@/utils/date.js'
import showMap from '@/components/showMapWindowMask'
import mapDropPin from '../../assets/map_icon/map_drop_pin.png'
export default {
  components: {MainLayout, showMap},
  data () {
    return {
      userShiftInfo: '',
      name: '',
      namekana: ''

    }
  },
  created () {
    // 初始化数据
    this.name = this.$route.query.name
    this.namekana = this.$route.query.namekana
    this.userShiftInfo = JSON.parse(sessionStorage.getItem('userShiftInfo'))
  },
  methods: {
    // 返回便一览页面
    goback () {
      this.$router.push({ name: 'MemberListOrderAndDetail', params: {orderDetailTime: this.$route.query.orderDetailTime} })
    //   this.$router.go(-1)
    },
    // 转化ステータス
    convertStatus (status) {
      switch (status) {
        case 1:
          return '予約確定'
        case 2:
          return 'キャンセル待ち'
        case 3:
          return '予約取消'
        case 4:
          return '予約失敗'
      }
    },
    // 转化予約受付方法
    convertReserveType (reserveType) {
      switch (reserveType) {
        case 1:
          return '電話'
        case 2:
          return 'アプリ'
      }
    },
    // 转化予約受付日時（yyyyMMddHHmmss转成yyyy年MM月dd日HH：mm）
    convertReserveTime (reserveTime) {
      return DateUtil.yearHourMinute(reserveTime)
    },
    // 转化利用日時（yyyyMMddHHmmss转成yyyy年MM月dd日（星期几））
    convertUseTime (useTime) {
      return DateUtil.yearWeek(useTime)
    },
    // 转化乘车/降车予定日時（yyyyMMddHHmmss转成HH：mm）
    convertEstimateTime (estimateTime) {
      return DateUtil.hourMinute(estimateTime)
    },
    // 地图显示乘车/降车位置
    map (PlaceLat, PlaceLng, PlaceName) {
      PlaceLat = parseFloat(PlaceLat)
      PlaceLng = parseFloat(PlaceLng)
      this.$refs.showMapWindow.mapTitle = PlaceName

      if ((Math.abs(PlaceLat) >= 0.0000000000000001) || (Math.abs(PlaceLng) >= 0.0000000000000001)) {
        // 图标样式
        let vehiclePoint = {
          lat: PlaceLat,
          lng: PlaceLng,
          icon: mapDropPin
        }
        var centerPoint = {
          lat: PlaceLat,
          lng: PlaceLng
        }
        this.$refs.showMapWindow.centerPoint = centerPoint
        this.$refs.showMapWindow.markPosition = vehiclePoint
      }

      this.$refs.showMapWindow.initiGoogleMap()
    }
  }
}
</script>

<template>
  <main-layout>
    <div class="col-md-12 column  main-containter">
      <div class="row clearfix containter-header">
        <div class="col-md-7 column headermiddle">
          乗車履歴 / 予約詳細
        </div>
        <div class="col-md-2 column headerleft">
          <input type="button" value="乗車履歴 / 予約一覧に戻る" @click="goback" />
        </div>
      </div>
      <div class="row clearfix tabledivs scrollbar">
        <table class="table table-bordered window-table">
          <tbody>
            <tr>
              <td class="td-key key-width">
                便名
              </td>
              <td colspan="3" class="td-value">
                {{userShiftInfo.shiftTitle}}
              </td>
            </tr>
            <tr>
              <td class="td-key key-width">
                便ID
              </td>
              <td colspan="3" class="td-value">
                {{userShiftInfo.shiftId}}
              </td>
            </tr>
            <tr>
              <td class="td-key key-width">
                予約ID
              </td>
              <td class="td-value value-width">
                {{userShiftInfo.reserveId}}
              </td>
              <td class="td-key key-width">
                ステ一タス
              </td>
              <td class="td-value value-width">
                {{convertStatus(userShiftInfo.status)}}
              </td>
            </tr>
            <tr>
              <td class="td-key key-width">
                フリガナ
              </td>
              <td class="td-value value-width">
                {{this.namekana}}
              </td>
              <td class="td-key key-width">
                予約受付方法
              </td>
              <td class="td-value value-width">
                {{convertReserveType(userShiftInfo.reserveType)}}
              </td>
            </tr>
            <tr>
              <td class="td-key key-width">
                乗客
              </td>
              <td class="td-value value-width">
                {{this.name}}
              </td>
              <td class="td-key key-width">
                予約受付日時
              </td>
              <td class="td-value value-width">
                {{convertReserveTime(userShiftInfo.reserveTime)}}
              </td>
            </tr>
            <tr>
              <td class="td-key key-width">
                乗車人数
              </td>
              <td colspan="3" class="td-value">
                {{userShiftInfo.passengerNumber}}名
              </td>
            </tr>
            <tr>
              <td class="td-key key-width">
                利用日
              </td>
              <td colspan="3" class="td-value">
                {{convertUseTime(userShiftInfo.useTime)}}
              </td>
            </tr>
            <tr>
              <td class="td-key key-width">
                乗車場所
              </td>
              <td class="td-value value-width">
                <div class="row clearfix">
                  <div class="col-md-10 column overflow-fix"> {{userShiftInfo.startPlaceName}}</div>
                  <div class="col-md-2 column">
                    <a href="#modal-container-staySave" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                      <button class="mapbtn F2-M-15 detailed-button" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;" @click="map(userShiftInfo.startPlaceLat,userShiftInfo.startPlaceLng,'乗車場所:' + userShiftInfo.startPlaceName)">
                        マップ
                      </button>
                    </a>
                  </div>
                </div>
              </td>
              <td class="td-key key-width">
                乗車予定時間
              </td>
              <td class="td-value value-width">
                {{convertEstimateTime(userShiftInfo.startEstimateTime)}}
              </td>
            </tr>
            <tr>
              <td class="td-key key-width">
                降車場所
              </td>
              <td class="td-value value-width">
                <div class="row clearfix">
                  <div class="col-md-10 column overflow-fix"> {{userShiftInfo.arrivePlaceName}}</div>
                  <div class="col-md-2 column">
                    <a href="#modal-container-staySave" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                      <button class="mapbtn F2-M-15 detailed-button" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;" @click="map(userShiftInfo.arrivePlaceLat,userShiftInfo.arrivePlaceLng,'降車場所:' + userShiftInfo.arrivePlaceName)">
                        マップ
                      </button>
                    </a>
                  </div>
                </div>
              </td>
              <td class="td-key key-width">
                到着予定時間
              </td>
              <td class="td-value value-width">
                {{convertEstimateTime(userShiftInfo.arriveEstimateTime)}}
              </td>
            </tr>
            <tr>
              <td class="td-key key-width">
                利用料金
              </td>
              <td colspan="3" class="td-value">
                {{userShiftInfo.passengerCost}}円
              </td>
            </tr>
            <tr>
              <td class="td-key" style="width:13%;text-align: center;line-height:90px">
                備考
              </td>
              <td colspan="3" class="td-value">
                {{userShiftInfo.note}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <showMap ref="showMapWindow"></showMap>
  </main-layout>
</template>

<style lang="scss" scoped>
@import "../../assets/css/C00.css";
@import '../../assets/css/globalStyle02.scss';
.main-containter{
  flex:1;
  display:flex;
  flex-direction: column;
  margin-bottom: 30px;
  margin-top:18px
}
.containter-header{
  flex:0 0 40px;
  position: relative;
}
.headerleft {
  vertical-align: bottom;
  margin-left:13px;
  width: 300px;
  background: url(../../assets/button/back_button.png) no-repeat 10px center;
}
.headerleft  input {
  float: left;
  border: none;
  background: none;
  line-height: 40px;
  width: 100%;
  text-indent: 30px;
  font-size: 18px;
}
.headermiddle {
  position: absolute;
  width: 100%;
  line-height: 40px;
  font-size: 24px;
}
.tabledivs {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: 10px;
  margin-top: 10px;
}
.window-table{
  font-size: 18px;
  border: 2px solid rgb(148, 148, 148);
  width: 99.8%;
 }
.table-bordered>tbody>tr>td{
  border: 1px solid rgb(148, 148, 148);
}
.td-title{
  background-color: #797979;
  color: #fff;
  font-size: 22px;
}
.td-key{
    // F3-R-15
  font-family: 'Noto Sans CJK JP';
  color: rgb(80, 80, 80);
  font-size: 15px ;
  font-weight: 400 ;
  background: $bgc8
}
.table>tbody>tr>td{
  padding:9px;
}
.table>tbody>tr>.td-value{
  padding-left: 30px;
}
.td-value{
  text-align: left;
  border: 1px solid #959595;
  // F3-M-18
  font-family: 'Noto Sans CJK JP';
  color: rgb(80, 80, 80);
  font-size: 18px;
  font-weight: 500;
  background: $bgc7
}
  //统一的地图按钮样式
  .mapbtn{
  height: 30px;
  width: 80px;
  font-size: 18px;
  border: none;
  background-color: #DDDDDD;
  border-radius: 4px;
  float: right;
  margin-right: 0.5%;
  color:black;
}
.key-width{
    width: 15%;
}
.value-width{
    width: 35%;
}

</style>



// WEBPACK FOOTER //
// src/router/views/MemberList_RecordOrOrderDetail.vue